export const sleekmodern = {
  name: 'Sleek & Modern',
  color: [0.6941176470588235, 0.8431372549019608, 0.8235294117647058, 1],
  bg: [0.00784313725490196, 0.10980392156862745, 0.11764705882352941, 1],
  grid1: [1, 1, 1, 1],
  grid2: [0.22745098039215686, 0.3176470588235294, 0.6, 1],
}
